module.exports = __webpack_public_path__ + "static/media/The path.efd05b5f.png";